// extracted by mini-css-extract-plugin
export var icon = "BlackHalvaLogo-module--icon--30zFT";